var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container pb-8"},[_c('div',{staticClass:"bg-light p-6 p-md-8 edit"},[_c('p',{staticClass:"px-md-6",domProps:{"innerHTML":_vm._s(_vm.noviceContent)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }